/**
 * A service to implement functions related to Groups:
 * 1 - the function to get all the Groups which should be displayed on the online Store; this function enables
 *  assigning parameters to the URL
 * 2 - the function to get the Sub Groups of a specific Group
 */

import {apiFetch} from '@/_helpers';


export const groupsService = {
    getAll,
    get,
};


/**
 * A function to get all the Groups which should be displayed on the online Store. This function enables
 *  assigning parameters to the URL. Right now, the parameters are used to:
 *  (1) obtain the Groups defined with a certain level (param=level);
 *  (2) obtain the Sub Groups of a Group (param=group).
 *
 * @param params
 * @returns {*}
 */
function getAll(params) {
    let objectFetch = null;
    let str = null;

    if (params) {
        str = Object.entries(params).map(([key, val]) => `${key}=${val}`).join('&');
    }

    if (str) {
        objectFetch = apiFetch("groups/?" + str);

    } else {
        objectFetch = apiFetch("groups/");
    }

    return objectFetch
}


/**
 * A function to get the Sub Groups of a specific Group.
 *
 * @param pk Group's identifier
 * @returns {*}
 */
function get(pk) {
    return apiFetch("groups/" + pk + "/");
}